import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    alerts: [],
};

const alertSlice = createSlice({
    name: 'alert',
    initialState,
    reducers: {
        showAlert: (state, action) => {
            const id = Date.now() + Math.random();
            state.alerts.push({
                id,
                message: action.payload.message,
                type: action.payload.type,
                timeout: action.payload.timeout || 10000,
                visible: true,
            });
        },
        hideAlert: (state, action) => {
            state.alerts = state.alerts.filter(alert => alert.id !== action.payload.id);
        },
    },
});

export const { showAlert, hideAlert } = alertSlice.actions;
export default alertSlice.reducer;